import { Button } from '@arcadiapower/design-system';
import { Provider } from '@schema/schemas';
import error from '@client/assets/icons/error.svg';
import { useTranslation } from 'react-i18next';
import InlineSVG from 'react-inlinesvg';
import { ty } from '@client/styles/typography';
import { ContentSectionFullHeight } from '../connect-container';
import { Actions, Centered, MessageStack } from './mfa-failure.style';

export type Props = {
  provider: Provider;
  onProviderReselect?: () => void;
};

export const MfaFailureScreen = ({ provider, onProviderReselect }: Props): JSX.Element => {
  const { t } = useTranslation('connect', { keyPrefix: 'components.mfaFailure' });

  const getFailureText = (): string => {
    return t('error', { providerName: provider.name });
  };
  return (
    <ContentSectionFullHeight>
      <Centered>
        <InlineSVG src={error} height="48px" width="48px" />
        <MessageStack>
          <p className={ty('paragraph600')} style={{ textAlign: 'center' }}>
            {getFailureText()}
          </p>
          <Actions>
            {!!onProviderReselect && (
              <>
                <p className={ty('paragraph600')} style={{ textAlign: 'center' }}>
                  {t('selectDescription')}
                </p>
                <Button
                  type="button"
                  variant="link"
                  className="h-auto rounded-sm p-0"
                  onClick={onProviderReselect}
                >
                  {t('reselectUtility')}
                </Button>
              </>
            )}
          </Actions>
        </MessageStack>
      </Centered>
    </ContentSectionFullHeight>
  );
};
